import { createAsyncThunk } from '@reduxjs/toolkit';

// Import helpers
import { subscriberDetails, logout, fetchSubscriberProductsUuids, subscriberInLocal } from 'helpers/api/subscriber';
import { fetchPacketList } from 'helpers/api/products';

export const fetchSubscriberDetails = createAsyncThunk('subscriber/subscriberDetails', subscriberDetails);

export const subscriberLogout = createAsyncThunk('subscriber/subscriberLogout', logout);

export const fetchSubscriberPackets = createAsyncThunk('subscriber/subscriberPackets', async () => {
	try {
		// list of packets (main|premium|provision) available in the system
		const packetList = await fetchPacketList({ limit: 2000, offset: 0 });
		// list of products uuids to which the user has access
		const products = await fetchSubscriberProductsUuids();
		// list of user packets
		const packets = packetList.filter(({ uuid }) => products.includes(uuid));
		return { packets, products };
	} catch (error) {
		return { packets: [], products: [] };
	}
});

export const fetchSubscriberProducts = createAsyncThunk('subscriber/subscriberProducts', fetchSubscriberProductsUuids);

export const fetchSubscriberInLocal = createAsyncThunk('subscriber/InLocal', subscriberInLocal);
